import { t } from 'i18next';

import { ErrorResponseErrorItemCodeSubscription } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeSubscription, string> => ({
  'subscription:url_not_whitelisted': t('subscription.urlNotWhitelisted', {
    ns: 'apiErrorCodes',
    defaultValue: 'URL:en är inte vitlistad.',
  }),
  'subscription:not_found': t('subscription.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Integrationen kunde inte hittas.',
  }),
});
